import { isArray, isNil } from "lodash";

export const DEFAULT_AUTO_ID_KEY = "id";

const DEFAULT_AUTO_ID_SEPARATOR = "__";

export const extractPrefix = (key) => {
  const parts = key.split(DEFAULT_AUTO_ID_SEPARATOR);
  return parts.length === 1 ? null : parts[0];
};

const generatePrefix = (prefixKey, entry) =>
  isNil(prefixKey) || !(prefixKey in entry)
    ? ""
    : entry[prefixKey] + DEFAULT_AUTO_ID_SEPARATOR;

export const autoIdSequentialTransform =
  ({ idKey = DEFAULT_AUTO_ID_KEY, initialValue = 0, prefixKey = null }) =>
  (response) => {
    if (isArray(response)) {
      let identifier = initialValue;
      return response.map((entry) => {
        entry[idKey] = generatePrefix(prefixKey, entry) + ++identifier;
        return entry;
      });
    }
    return response;
  };

export const autoIdUUIDTransform =
  ({ idKey = DEFAULT_AUTO_ID_KEY, prefixKey = null }) =>
  (response) => {
    if (isArray(response)) {
      return response.map((entry) => {
        entry[idKey] = generatePrefix(prefixKey, entry) + crypto.randomUUID();

        return entry;
      });
    }
    return response;
  };

export const autoIdJSON64EncodedTransform =
  ({ idKey = DEFAULT_AUTO_ID_KEY, prefixKey = null }) =>
  (response) => {
    if (isArray(response)) {
      const keyCounts = new Map();
      return response.map((entry) => {
        entry[idKey] =
          generatePrefix(prefixKey, entry) +
          btoa(
            JSON.stringify(entry)
              .split("")
              .filter((character) => character.charCodeAt(0) < 128)
              .join("")
          );

        // Check if this key is a duplicate, and if so, add a suffix
        if (!keyCounts.has(entry[idKey])) {
          keyCounts.set(entry[idKey], 1);
        } else {
          const currentCount = keyCounts.get(entry[idKey]);
          keyCounts.set(entry[idKey], currentCount + 1);
          entry[idKey] = entry[idKey] + "_" + currentCount;
        }

        return entry;
      });
    }
    return response;
  };
